module.exports = __webpack_public_path__ + "img/language.09323f37.svg";